let tab_label = document.querySelectorAll('.tab__label');
let tab_content = document.querySelectorAll('.tab_content');

let switch__tab = event => {    
    let cur_btn =  event.target.closest('.tab__label');
    let label = cur_btn.dataset.class;


    for (const btn of tab_label) {
        if (btn == cur_btn){
            btn.classList.add('active')
        }else{
            btn.classList.remove('active')
        }
    }
    for (const tab of tab_content) {
        if(tab.dataset.label == label){
            tab.classList.add('active');
        }else{
            tab.classList.remove('active')
        }
    }

} 

tab_label.forEach( el => el.addEventListener('click', switch__tab));